import { toast } from 'react-toastify';

// Namuna sahifalardagi amal tugmalari (Tasdiqlash, Imzolash, Yuborish ...) hech qanday so'rov yubormaydi.
export const SAMPLE_ACTION_TEXT = 'Namuna rejimi: amal bajarilmadi';

export function sampleAction() {
  toast.info(SAMPLE_ACTION_TEXT, { toastId: 'sample-action' });
}
